import { AuthTokens } from '../interfaces/auth';
import { AccountProfile, UpdateAccountInput, UpdateUserSettings, UserSettings } from '../interfaces/settings';
import { json, problem, type PathDef } from '../../util/pathDef';

export const settingsGet: PathDef = {
  method: 'get',
  path: '/settings',
  handler: 'domains/bff/src/settings/get/index.handler',
  tags: ['settings'],
  summary: 'Get user settings',
  description: 'Returns preferences for the authenticated user. Missing rows return defaults.',
  security: 'bearerAuth',
  responses: {
    200: json('User settings', UserSettings),
    401: problem('Unauthorized'),
  },
};

export const settingsPut: PathDef = {
  method: 'put',
  path: '/settings',
  handler: 'domains/bff/src/settings/put/index.handler',
  tags: ['settings'],
  summary: 'Update user settings',
  description: 'Partial merge of preferences for the authenticated user.',
  security: 'bearerAuth',
  request: UpdateUserSettings,
  responses: {
    200: json('Updated settings', UserSettings),
    400: problem('Invalid request'),
    401: problem('Unauthorized'),
  },
};

export const accountGet: PathDef = {
  method: 'get',
  path: '/account',
  handler: 'domains/bff/src/account/get/index.handler',
  tags: ['settings'],
  summary: 'Get the caller Cloud account profile',
  description: 'Partner sessions only. Returns first name, last name, and email.',
  security: 'bearerAuth',
  responses: {
    200: json('Account profile', AccountProfile),
    401: problem('Unauthorized'),
    404: problem('Not found'),
    502: problem('Users service unavailable'),
  },
};

export const accountPut: PathDef = {
  method: 'put',
  path: '/account',
  handler: 'domains/bff/src/account/put/index.handler',
  tags: ['settings'],
  summary: 'Update the caller Cloud account profile',
  description: 'Partner sessions only. Updates first name and last name. Email cannot change. Returns new session tokens.',
  security: 'bearerAuth',
  request: UpdateAccountInput,
  responses: {
    200: json('Updated session', AuthTokens),
    400: problem('Invalid request'),
    401: problem('Unauthorized'),
    404: problem('Not found'),
    502: problem('Users service unavailable'),
  },
};

export const settingsPaths: PathDef[] = [settingsGet, settingsPut, accountGet, accountPut];
